import utils from "./react-form-utils";
export const setValue = utils.set;
export const getValue = (obj, path, def) => {
    const val = utils.get(obj, path, def);
    if (val === null && def) {
        return def;
    }
    return val;
}
